import React, { useState } from "react";
import { getText } from "../../lang";
import feedbackActions from "../../actions/feedbackActions";
import { notifyError, notifySuccess } from "../../utils/Notify";
import MatButton from "../../components/MatButton";
import MatRow from "../../components/MatRow";
import InputTextarea from "../../components/InputTextarea";

const NpsFeedbackPage = ({
  onClickBack,
  onSendButton,
  id,
  invitation,
  isPreview = false,
}) => {
  const [value, setValue] = useState("");

  return (
    <>
      <div className="nps-feedback-title strong">
        {getText("TITLE_FEEDBACK_NEG", invitation?.language || "en")}
      </div>
      <div className="nps-feedback-title">
        {invitation.reviewInviteNegativePage}
      </div>
      <InputTextarea
        placeholder={getText(
          "TEXT_FEEDBACK_NEG_INPUT_PLACEHOLDER",
          invitation?.language || "en"
        )}
        minRows={4}
        maxRows={6}
        onChange={(e) => {
          setValue(e.target.value);
        }}
        value={value}
        onClear={() => {
          setValue("");
        }}
      />
      <MatRow className="feedback-button-wrapper">
        <MatButton
          buttonText={getText("ACTION_BACK", invitation?.language || "en")}
          size={"large"}
          typeButton="cancel"
          disabled={isPreview}
          onClick={() => {
            onClickBack && onClickBack();
          }}
        />
        <MatButton
          buttonText={getText("ACTION_SEND", invitation?.language || "en")}
          size={"large"}
          disabled={isPreview}
          onClick={async () => {
            if (value) {
              const result = await feedbackActions.sendNegative(id, value);
              if (result.success) {
                notifySuccess(
                  getText(
                    "NTF_SUCCESS_SEND_FEEDBACK",
                    invitation?.language || "en"
                  )
                );
                onSendButton && onSendButton();
              }
            } else {
              notifyError(
                getText("ERR_NO_FEEDBACK", invitation?.language || "en")
              );
            }
          }}
        />
      </MatRow>
    </>
  );
};

export default NpsFeedbackPage;
